import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { Button } from '@peacecover/component';
import { usePhotoCardMarketPopupStore } from '../store/usePhotoCardMarketPopupStore';
import type { ChatRoomType } from '../types/MarketCardType';

interface ReviewButtonProps {
  tradingPhotoCardId: string;
  chat: ChatRoomType;
  requestChatCount: number;
}

const ReviewButton = ({ tradingPhotoCardId, chat, requestChatCount }: ReviewButtonProps) => {
  const navigate = useNavigate();
  const { setIsBeforeReviewPopupOpen, setIsWriteReviewPopupOpen, setSelectedTradingPhotoCard } =
    usePhotoCardMarketPopupStore();

  switch (chat?.reviewStatus) {
    case 'none':
      return null;
    case 'disabled':
      return (
        <Button
          size="small"
          variant="line"
          btnColor="gray"
          className="px-[12px] text-on-disable dark:border-separator1 text-[13px]"
        >
          {t('NewTradingPhotoCardMarket.reviewButton.writeReview')}
        </Button>
      );
    case 'request':
      return (
        <Button
          size="small"
          variant="line"
          btnColor="primary"
          className="px-[12px] text-primary text-[13px]"
          onClick={() => {
            if (requestChatCount < 2) {
              navigate(
                `/reviews/add-review?chatRoomId=${chat.chatRoomId}&traderUserProfileId=${chat.traderProfileId}&reviewableId=${tradingPhotoCardId}&reviewableType=${chat.subjectType}`
              );
              return;
            }
            setIsWriteReviewPopupOpen(true);
            setSelectedTradingPhotoCard({
              tradingPhotoCardId,
              chatRoomId: chat.chatRoomId,
              traderUserProfileId: chat.traderProfileId,
              reviewableType: chat.subjectType
            });
          }}
        >
          {t('NewTradingPhotoCardMarket.reviewButton.writeReview')}
        </Button>
      );
    case 'received':
      return (
        <Button
          size="small"
          variant="solid"
          btnColor="secondary"
          onClick={() => {
            if (chat.sentReviewId) {
              // 보낸 리뷰가 있다면 리뷰 상세 페이지로 이동
              navigate(`/reviews/${chat.receivedReviewId}`);
              return;
            }

            navigate(`/reviews/trade-review-request?reviewId=${chat.receivedReviewId}`);
          }}
          className="px-[12px] text-on-secondary text-[13px]"
        >
          {t('NewTradingPhotoCardMarket.reviewButton.viewReview')}
        </Button>
      );
    case 'pending':
      return (
        <Button
          size="small"
          variant="normal"
          btnColor="gray"
          className="px-[12px] text-text-main-lv2 bg-on-primary dark:bg-transparent border border-separator1 text-[13px]"
          onClick={() => {
            setIsBeforeReviewPopupOpen(true);
          }}
        >
          {t('NewTradingPhotoCardMarket.reviewButton.beforeReview')}
        </Button>
      );
  }
};

export default ReviewButton;
